import { CustomerMeal } from './CustomerMeal'
import { LocalDate } from 'local-date'
import { DinneyObject } from './DinneyObject'
import { Billing } from './Billing'
import { PaymentSummary } from './PaymentSummary'

export class Customer implements DinneyObject {

    customerid? : number
    firstName : string
    lastName : string
    childName : string
    activeStart : LocalDate
    activeEnd : LocalDate
    email : string
    description : string
    position : number
    active : boolean
    parentGotAccount : boolean
    billings : Billing[]
    paymentSummary? : PaymentSummary
    customerMeals? : CustomerMeal[]

    constructor(firstName : string, 
                lastName : string, 
                childName : string, 
                activeStart : LocalDate, 
                activeEnd : LocalDate, 
                email : string, 
                description : string,
                position : number,
                active : boolean,
                parentGotAccount : boolean,
                billings : Billing[],
                paymentSummary? : PaymentSummary,
                customerMeals? : CustomerMeal[],
                customerid? : number
                ) {
            
        this.firstName = firstName
        this.lastName = lastName
        this.childName = childName
        this.activeStart = activeStart
        this.activeEnd = activeEnd
        this.email = email
        this.description = description
        this.position = position
        this.active = active
        this.billings = billings
        this.paymentSummary = paymentSummary
        this.customerMeals = customerMeals
        this.customerid = customerid
        this.parentGotAccount = parentGotAccount
    }
}